import { IDisplayInfoIcon } from '@caslink/device-client/ng-app/shared/models/types';
import {DisplayIconFactory} from './display-icon-factory.interface';
import { ICardDataViewModel } from '@caslink/device-client/ng-app/shared/models/models';

export class OccupiedFactory implements DisplayIconFactory {
    public createDisplayIcon(item: ICardDataViewModel): IDisplayInfoIcon {
        const icon: IDisplayInfoIcon = {
            ...this.createPartialIcon(() => !!item.actualValue),
            getLabelText: () => item.displayValue || item.name,
            isLabelVisible: () => true,
            getValue: () => item.displayValue || item.value,
        };

        return icon;
    }

    public createDisplayIconForBehavior(getIsOn: () => boolean): IDisplayInfoIcon {
        const icon: IDisplayInfoIcon = {
            ...this.createPartialIcon(getIsOn),
            getLabelText: () => '',
            isLabelVisible: () => false,
            getValue: () => getIsOn() ? 'true' : 'false',
        };

        return icon;
    }

    private createPartialIcon(getIsOn: () => boolean): Partial<IDisplayInfoIcon> {
        const icon: Partial<IDisplayInfoIcon> = {
            materialIcon: getIsOn() ? 'person' : 'person_outline',
        };

        return icon;
    }
}
